/* eslint-disable no-undef */

import Utils from "@/Utils";

let dialogCloseFunctions = []

// this gets called by the android webview client, do NOT remove it.
window.closeTopDialog = () => {
  console.log(`closeTopDialog ${dialogCloseFunctions.length}`)
  if(dialogCloseFunctions && dialogCloseFunctions.length > 0) {
    let func = dialogCloseFunctions[dialogCloseFunctions.length - 1] //don't pop--it'll get popped when setFullscreen(false) is called upond dialog closing.
    func()
  }
}

class AndroidInterface {

  shouldFetchLocalizedPricing() {
    return this.installedFromGooglePlay() && typeof JavascriptToAndroidInterface !== 'undefined' && typeof JavascriptToAndroidInterface.getLocalizedPrice !== 'undefined';
  }

  async fetchLocalizedPricing(subscriptionId) {

    console.log(`fetching pricing for ${subscriptionId}`)

    let localizedPrice = null
    let attempt = 0
    while (!localizedPrice && attempt < 100) {
      localizedPrice = JavascriptToAndroidInterface.getLocalizedPrice(subscriptionId)
      console.log(`fetching pricing for ${subscriptionId} returned ${localizedPrice}`)
      if (!localizedPrice) {
        await Utils.sleep(250)
      }
      attempt++
    }

    return localizedPrice
  }

  installedFromGooglePlay() {
    if(typeof JavascriptToAndroidInterface !== 'undefined') {

      if(typeof JavascriptToAndroidInterface.getInstalledAppPackageName !== 'undefined') {
        //returns com.android.vending if installed from Google Play Store
        const installingPackage = JavascriptToAndroidInterface.getInstalledAppPackageName()
        console.log(`installingPackage = ${installingPackage}`)
        return installingPackage === 'com.android.vending' || installingPackage === 'com.google.android.feedback' || installingPackage === null || installingPackage === undefined
      } else {
        return true //if they're on an older version of the app that doesn't have that function then they installed from Google Play
      }
    } else {
      return null
    }
  }

  getInstalledPackageName() {
    if(typeof JavascriptToAndroidInterface !== 'undefined') {

      if(typeof JavascriptToAndroidInterface.getInstalledAppPackageName !== 'undefined') {
        const installingPackage = JavascriptToAndroidInterface.getInstalledAppPackageName()
        return installingPackage
      } else {
        return 'getInstalledAppPackageName is undefined' //if they're on an older version of the app that doesn't have that function then they installed from Google Play
      }
    } else {
      return 'JavascriptToAndroidInterface is undefined'
    }
  }

  getApplicationId() {
    if(typeof JavascriptToAndroidInterface !== 'undefined' && typeof JavascriptToAndroidInterface.getApplicationId !== 'undefined') {
      return JavascriptToAndroidInterface.getApplicationId()
    }
    return null
  }

  getCredentials() {
    if(typeof JavascriptToAndroidInterface !== 'undefined') {
      return JavascriptToAndroidInterface.getCredentials()
    } else {
      return null
    }
  }

  /**
   * Communicates to the android app that a dialog or something else is opened that should allow the app to use the full screen
   * and hide the toolbar.
   * @param val
   */
  /**
   * Intercepts the Android back button without entering fullscreen.
   * When back is pressed, closeFunc is called instead of closing the activity.
   */
  setBackIntercept(val, closeFunc) {
    console.log(`setBackIntercept ${val}`)
    if(typeof JavascriptToAndroidInterface !== 'undefined') {
      if(val) {
        dialogCloseFunctions.push(closeFunc)
      } else {
        dialogCloseFunctions.pop()
      }

      if(typeof JavascriptToAndroidInterface.setBackIntercept !== 'undefined') {
        JavascriptToAndroidInterface.setBackIntercept(val)
      }
    }
  }

  setFullscreen(val, closeFunc) {
    console.log(`setFullscreen ${val}`)
    if(typeof JavascriptToAndroidInterface !== 'undefined') {

      if(val) {
        dialogCloseFunctions.push(closeFunc)
      } else {
        dialogCloseFunctions.pop()
      }

      JavascriptToAndroidInterface.setFullscreen(val)
    }
  }

  /**
   * The Android WebView has no navigator.share. App builds from 2026-10-10
   * expose the system share sheet as JavascriptToAndroidInterface.shareText
   * (WebViewActivity); older builds lack it and canShare() is false, so the
   * page keeps to its other send buttons. Used by the invite link dialog.
   */
  canShare() {
    return typeof JavascriptToAndroidInterface !== 'undefined' && typeof JavascriptToAndroidInterface.shareText !== 'undefined'
  }

  /** Opens the share sheet with text and, on its own line after it, the url. */
  share(title, text, url) {
    if(!this.canShare()) {
      return false
    }
    JavascriptToAndroidInterface.shareText(title || '', text || '', url || '')
    return true
  }

  /**
   * Inside the Android app an <input type="file"> only opens a picker when the
   * app wires one up (WebViewActivity's WebChromeClient.onShowFileChooser, app
   * builds from 2026-10-10, announced by JavascriptToAndroidInterface.canChooseFiles).
   * Older builds have no picker at all - the input silently does nothing - and
   * lack the method, so this is false there and the support chat hides its
   * "Choose file" option. Only meaningful in the app; a browser needs no bridge.
   */
  canChooseFiles() {
    try {
      return typeof JavascriptToAndroidInterface !== 'undefined'
        && typeof JavascriptToAndroidInterface.canChooseFiles !== 'undefined'
        && JavascriptToAndroidInterface.canChooseFiles() === true
    } catch (e) {
      console.warn('canChooseFiles failed', e)
      return false
    }
  }

  getAppVersion() {
    if(typeof JavascriptToAndroidInterface !== 'undefined') {
      return JavascriptToAndroidInterface.getAppVersion()
    }
    return undefined
  }

  openWebsiteInBrowser(url) {
    console.log(`openWebsiteInBrowser ${url}`)
    if(typeof JavascriptToAndroidInterface !== 'undefined') {
      JavascriptToAndroidInterface.openWebsiteInBrowser(url)
    }
  }

  openAppPageInBrowser(page) {
    console.log(`openAppPageInBrowser ${page}`)
    if(typeof JavascriptToAndroidInterface !== 'undefined') {
      JavascriptToAndroidInterface.openAppPageInBrowser(page)
    }
  }

  openAbout() {
    if(typeof JavascriptToAndroidInterface !== 'undefined' && typeof JavascriptToAndroidInterface.openAbout !== 'undefined') {
      JavascriptToAndroidInterface.openAbout()
    }
  }

  openBatteryOptimization() {
    if(typeof JavascriptToAndroidInterface !== 'undefined' && typeof JavascriptToAndroidInterface.openBatteryOptimization !== 'undefined') {
      JavascriptToAndroidInterface.openBatteryOptimization()
    }
  }

  checkForFailedGooglePlayPurchases() {
    if(typeof JavascriptToAndroidInterface !== 'undefined' && typeof JavascriptToAndroidInterface.checkForFailedGooglePlayPurchases !== 'undefined') {
      JavascriptToAndroidInterface.checkForFailedGooglePlayPurchases()
    }
  }

  canUseGooglePlayForPurchases() {
    if(typeof JavascriptToAndroidInterface !== 'undefined' && typeof JavascriptToAndroidInterface.purchaseGooglePlayInAppSubscriptionV2 !== 'undefined') {
      console.log('canUseGooglePlayForPurchases true')
      return true
    }
    if(typeof JavascriptToAndroidInterface !== 'undefined' && typeof JavascriptToAndroidInterface.purchaseGooglePlayInAppSubscription !== 'undefined') {
      console.log('canUseGooglePlayForPurchases true')
      return true
    }
    console.log('canUseGooglePlayForPurchases false')
    return false
  }

  purchaseThroughGooglePlay(subscriptionId, plan, price) {
    //v2
    if(typeof JavascriptToAndroidInterface !== 'undefined' && typeof JavascriptToAndroidInterface.purchaseGooglePlayInAppSubscriptionV2 !== 'undefined') {
      JavascriptToAndroidInterface.purchaseGooglePlayInAppSubscriptionV2(subscriptionId, plan, price)
      return
    }

    //v1
    if(typeof JavascriptToAndroidInterface !== 'undefined' && typeof JavascriptToAndroidInterface.purchaseGooglePlayInAppSubscription !== 'undefined') {
      JavascriptToAndroidInterface.purchaseGooglePlayInAppSubscription(subscriptionId)
      return
    }
  }

  /**
   * App builds with the diagnostics report (2026-10) expose
   * JavascriptToAndroidInterface.canAttachDeviceLogs / requestDeviceLogs / getDeviceLogs: the app's
   * main process writes one .txt (device + account info, permissions, 7 days of app log, crashes,
   * recent logcat, SHA-256 footer) and the support chat attaches it like the web app logs. Older
   * builds lack the methods, so the "Device logs" option stays hidden there. In-app only.
   */
  canAttachDeviceLogs() {
    try {
      return typeof JavascriptToAndroidInterface !== 'undefined'
        && typeof JavascriptToAndroidInterface.canAttachDeviceLogs !== 'undefined'
        && typeof JavascriptToAndroidInterface.requestDeviceLogs !== 'undefined'
        && typeof JavascriptToAndroidInterface.getDeviceLogs !== 'undefined'
        && JavascriptToAndroidInterface.canAttachDeviceLogs() === true
    } catch (e) {
      console.warn('canAttachDeviceLogs failed', e)
      return false
    }
  }

  /**
   * Builds the device diagnostics report and resolves to {fileName, sha256, text}. The build runs
   * in the app's main process and takes a few seconds (SQLite queries, a logcat dump, the merged
   * log), so the bridge works like getLocalizedPrice: start it, then poll until it is ready.
   */
  async getDeviceLogs(timeoutMs = 90000) {
    if (!this.canAttachDeviceLogs()) {
      throw new Error('device logs are not available in this app build')
    }
    const requestId = JavascriptToAndroidInterface.requestDeviceLogs()
    const started = Date.now()
    while (Date.now() - started < timeoutMs) {
      const raw = JavascriptToAndroidInterface.getDeviceLogs(requestId)
      if (raw) {
        const result = JSON.parse(raw)
        if (result.status === 'ready') {
          return result
        }
        throw new Error(result.message || 'the app could not build the device logs')
      }
      await Utils.sleep(500)
    }
    throw new Error('timed out waiting for the app to build the device logs')
  }

  changeThroughGooglePlay(subscriptionId, purchaseToken) {
    console.log(`calling ${JavascriptToAndroidInterface.changeGooglePlayInAppSubscription}`)
    JavascriptToAndroidInterface.changeGooglePlayInAppSubscription(purchaseToken, subscriptionId)
  }
}

export default (new AndroidInterface())
